export default (date) => {
  if (date instanceof Date) {
    const year = date.getFullYear();
    let month = date.getMonth() + 1;
    if (month < 10) month = '0' + month;

    return `${year}-${month}`;
  } else if (typeof date === 'undefined') {
    return '';
  } else {
    return date;
  }
};



// WEBPACK FOOTER //
// ./src/gadgets/monthFormatter.js